let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iWBVp")).then(() => parcelRequire('3UqVx'));